
export class RegisteredManufacturingOrder {
  constructor(
    public code: string
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/registered-manufacturing-order.ts